import _ from 'lodash';
import type { RootState } from 'src/redux/store';
import { convertArrayType } from 'src/utils/query-string';

export const getRecommendations = (state: RootState) => state.recommendations;

export const getHiddenRecommendations = (state: RootState) =>
  state.hiddenRecommendations;

export const getInputs = (state: RootState) => state.inputs;

export const getTuCreditScoreBand = (state: RootState) =>
  state.userData.tuCreditScoreBand;

export const getExperiments = (state: RootState) => state.experiments;

export const getInputQueryParams = (state: RootState) =>
  state.queryParams.inputs;

export const getIsReturnUser = (state: RootState) =>
  state.userData.isReturnUser;

export const getIsSignedIn = (state: RootState) => state.userData.isSignedIn;

export const getUserEmail = (state: RootState) => state.userData.userEmail;

export const getExcludeInstitution = (state: RootState) =>
  state.queryParams.excludeInstitution;

export const getExperimentOverrides = (state: RootState) =>
  state.queryParams.experimentOverrides;

export const getIsMobileApp = (state: RootState) =>
  state.queryParams?.isMobileApp;

export const getAuth0Variant = (state: RootState) =>
  convertArrayType(state.queryParams?.auth0Variant);

export const getAuth0State = (state: RootState) =>
  convertArrayType(state.queryParams?.auth0State);

export const getAuth0AnonymousId = (state: RootState) =>
  convertArrayType(state.queryParams?.auth0AnonymousId);

export const getQuickEditIsVisible = (state: RootState) =>
  state.quickEdit.isVisible;

export const getQuickEditInputs = (state: RootState) => state.quickEdit.inputs;

export const getQuickEditQuestions = (state: RootState) =>
  state.quickEdit.questions;

export const getFormSubmitId = (state: RootState) => state.form.formSubmitId;

export const getPageNumber = (state: RootState) => state.form.pageNumber;

export const getCurrentStep = (state: RootState) => state.form.currentStep;

export const getInitialScreen = (state: RootState) => state.form.initialScreen;

export const getVisitedScreens = (state: RootState) =>
  state.form.visitedScreens;

export const getIsQuickEditLoading = (state: RootState) =>
  state.quickEdit.loading;

export const selectPrimaryGoal = (state: RootState) => state.inputs.primaryGoal;

export const getQueryParams = (state: RootState) => state.queryParams;

export const getUserData = (state: RootState) => state.userData;
